"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Auth = _interopRequireDefault(require("composer-lib/data/model/Auth"));

var _constants = require("composer-lib/lib/constants");

var _ComposerSettings = _interopRequireDefault(require("composer-lib/data/model/ComposerSettings"));

var _Composition = _interopRequireDefault(require("composer-lib/data/model/Composition"));

var _reactRedux = require("react-redux");

var _Lock = _interopRequireDefault(require("composer-lib/data/model/Lock"));

var _lock = require("composer-lib/redux/actions/lock");

var _Presence = _interopRequireDefault(require("composer-lib/data/model/Presence"));

var _PresenceAvatars = _interopRequireDefault(require("composer-lib/components/presence/PresenceAvatars"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _users = require("composer-lib/redux/actions/users");

var _SaveState = _interopRequireDefault(require("composer-lib/data/model/SaveState"));

var _Users = _interopRequireDefault(require("composer-lib/data/model/Users"));

var mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.auth,
    composerSettings: state.composerSettings,
    composition: state.composition,
    lock: state.lock,
    presence: state.presence,
    saveState: state.save,
    users: state.users
  };
};

var mapDispatchToProps = {
  passLock: _lock.passLock,
  refetchUsers: _users.refetchUsers,
  rejectRequestLockFromUser: _lock.rejectRequestLockFromUser,
  requestLock: _lock.requestLock,
  requestLockFromUser: _lock.requestLockFromUser
};
var PresenceContainer = (0, _createReactClass.default)({
  displayName: "PresenceContainer",
  propTypes: {
    auth: _propTypes.default.instanceOf(_Auth.default).isRequired,
    composerSettings: _propTypes.default.instanceOf(_ComposerSettings.default).isRequired,
    composition: _propTypes.default.instanceOf(_Composition.default).isRequired,
    lock: _propTypes.default.instanceOf(_Lock.default).isRequired,
    offset: _propTypes.default.bool,
    passLock: _propTypes.default.func.isRequired,
    presence: _propTypes.default.instanceOf(_Presence.default).isRequired,
    refetchUsers: _propTypes.default.func.isRequired,
    rejectRequestLockFromUser: _propTypes.default.func.isRequired,
    requestLock: _propTypes.default.func.isRequired,
    requestLockFromUser: _propTypes.default.func.isRequired,
    saveState: _propTypes.default.instanceOf(_SaveState.default).isRequired,
    tooltipPlacement: _propTypes.default.string,
    users: _propTypes.default.instanceOf(_Users.default).isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      offset: false,
      tooltipPlacement: 'top right'
    };
  },
  render: function render() {
    var _this$props = this.props,
        auth = _this$props.auth,
        composerSettings = _this$props.composerSettings,
        composition = _this$props.composition,
        lock = _this$props.lock,
        offset = _this$props.offset,
        presence = _this$props.presence,
        saveState = _this$props.saveState,
        tooltipPlacement = _this$props.tooltipPlacement,
        users = _this$props.users;

    if (!composerSettings.features[_constants.ComposerFeatures.PRESENCE]) {
      return null;
    }

    return _react.default.createElement(_PresenceAvatars.default, {
      auth: auth,
      composition: composition,
      dropdownPlacement: "bottom right",
      lock: lock,
      offset: offset,
      passLock: this.props.passLock,
      presence: presence,
      refetchUsers: this.props.refetchUsers,
      rejectRequestLockFromUser: this.props.rejectRequestLockFromUser,
      requestLock: this.props.requestLock,
      requestLockFromUser: this.props.requestLockFromUser,
      saveState: saveState,
      tooltipPlacement: tooltipPlacement,
      users: users
    });
  }
});

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PresenceContainer);

exports.default = _default;
module.exports = exports.default;